import '@adornis/browser-shim';
//# sourceMappingURL=plugin-types.js.map
